<template>
  <div>
    <v-row v-if="detailLevel == 0" align="center" style="margin: 20px">
      <v-col class="d-flex" cols="2" sm="2">
        <b>سطح:</b>
      </v-col>
      <v-col class="d-flex" cols="8" sm="4">
        <v-select :items="items" item-text="text" item-value="value" v-model="type" @change="getAllCycles()"></v-select>
      </v-col>
    </v-row>
    <div v-if="cycles.length > 0">
      <div v-if="isMobile">
        <div v-if="detailLevel == 0">
          <app-cycle v-for="index in cycles.length" :key="index" :index="index - 1" :cycle="cycles[index - 1]"
            :selectedCourse="selectedCycle" @clicked="onClickCourse" :showDetails="false">
          </app-cycle>
        </div>
        <div v-else-if="detailLevel == 1">
          <!-- <app-cycle :index="selectedCourse" :cycle="cycles[selectedCourse]" :showDetails="true"
            :selectedVahed="selectedVahed">
          </app-cycle> -->
          <div class="courses">
            <v-card v-for="key in courses.length" :key="key" :index="key - 1">
              <v-card-title class="info-detail">
                <!-- <font-awesome-icon class="collapse" /> -->
                <div class="text-center text-padding">
                  {{ courses[key - 1].TitleName }}
                  <br />
                </div>
              </v-card-title>
              <div>
                <app-row icon="file-excel" title="نمره: " :value="courses[key - 1].Score" />
                <app-row icon="question-circle" title="وضعیت: " :value="courses[key - 1].State" />
                <!-- <app-row icon="file-excel" title="نمره اول:" :value="courses[key - 1].Score1" />
                <app-row icon="file-excel" title="نمره دوم:" :value="courses[key - 1].Score2" />
                <app-row icon="file-excel" title="نمره سوم:" :value="courses[key - 1].Score3" />
                <app-row icon="file-excel" title="نمره شفاهی:" :value="courses[key - 1].ScoreShafahi" />
                <app-row icon="file-excel" title="نمره تحقیق:" :value="courses[key - 1].ScoreResearch" /> -->
                <!-- <app-row icon="book" title="کد درس:" :value="courses[key - 1].ID" /> -->
                <app-row icon="user" title="نام استاد:" :value="courses[key - 1].TeacherName" />
                <app-row icon="book" title="پایه:" :value="courses[key - 1].PayehName" />
                <app-row icon="university" title="واحد:" :value="courses[key - 1].Vahed" />
                <app-row icon="book" title="متن درس:" :value="courses[key - 1].TextBook" />
                <!-- <app-row icon="clock" title="تعداد ساعت:" :value="courses[key - 1].Saat" />
                <app-row icon="hashtag" title="تعداد جلسات برگزار شده:" :value="courses[key - 1].BargozarShodeCount" />
                <app-row icon="check" title="تعداد حضور:" :value="courses[key - 1].HozoorCount" />
                <app-row icon="times-circle" title="تعداد غیبت:" :value="courses[key - 1].GheibatCount" />
                <app-row :showButton="true" buttonText="جزئیات حضور و غیاب" @clicked="{ }" /> -->
                <v-simple-table class="mobileGrid">
                  <tbody>
                    <tr>
                      <td>
                        <span><b>نمره اول: </b>{{ courses[key - 1].Score1 }}</span>
                      </td>
                      <td>
                        <span><b>تعداد ساعت: </b>{{ courses[key - 1].Saat }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span><b>نمره دوم: </b>{{ courses[key - 1].Score2 }}</span>
                      </td>
                      <td>
                        <span><b> جلسات برگزار شده: </b>{{ courses[key - 1].BargozarShodeCount }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span><b>نمره سوم: </b>{{ courses[key - 1].Score3 }}</span>
                      </td>
                      <td>
                        <span><b>تعداد حضور: </b>{{ courses[key - 1].HozoorCount }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span><b>نمره شفاهی: </b>{{ courses[key - 1].ScoreShafahi }}</span>
                      </td>
                      <td>
                        <span><b> تعداد غیبت: </b>{{ courses[key - 1].GheibatCount }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <span><b>نمره تحقیق: </b>{{ courses[key - 1].ScoreResearch }}</span>
                      </td>
                      <td dir="ltr">
                        <v-btn outlined class="grid" color="black white--text" rounded
                          @click="goToGheibat(courses[key - 1].ID)">
                          {{ "جزییات حضور و غیاب" }}
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>

              </div>
            </v-card>
          </div>
        </div>
      </div>
      <div v-else-if="detailLevel == 0">
        <div v-for="index in cycles.length" :key="index" :index="index - 1">
          <div style="margin: 20px">
            <b>دوره {{ cycles[index - 1].ID }}: </b>{{ cycles[index - 1].Name }}
          </div>
          <div style="display: flex">
            <div class="cycle-info">
              <b>تعداد واحد: </b>{{ cycles[index - 1].TotalVahed }}
            </div>
            <div class="cycle-info">
              <b>تعداد ساعت: </b>{{ cycles[index - 1].TotalSaat }}
            </div>
            <div class="cycle-info">
              <b>معدل: </b>{{ cycles[index - 1].Avrg }}
            </div>
          </div>
          <v-data-table :items="cycles[index - 1].Courses" :headers="courseHeaders" class="elevation-1"
            :disable-pagination="true" :hide-default-footer="true" :no-data-text="tableText" show-expand item-key="ID"
            single-expand>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <br />
                <v-row>
                  <!-- <v-col cols="12" lg="6">
                    <b>کد درس: </b>{{ item.ID }}
                  </v-col> -->
                  <v-col cols="12" lg="6">
                    <b>تعداد واحد: </b>{{ item.Vahed }}
                  </v-col>
                  <v-col cols="12" lg="6">
                    <b>پایه: </b>{{ item.PayehName }}
                  </v-col>
                </v-row>
                <v-row>

                  <v-col cols="12" lg="6">
                    <b>نام استاد: </b>{{ item.TeacherName }}
                  </v-col>
                  <v-col cols="12" lg="6">
                    <b>متن درس: </b>{{ item.TextBook }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="6">
                    <b>تعداد ساعت: </b>{{ item.Saat }}
                  </v-col>
                  <v-col cols="12" lg="6">
                    <b>تعداد جلسات برگزار شده: </b>{{ item.BargozarShodeCount }}
                  </v-col>
                </v-row>
                <v-row>

                  <v-col cols="12" lg="6">
                    <b>تعداد حضور: </b>{{ item.HozoorCount }}
                  </v-col>
                  <v-col cols="12" lg="6">
                    <b>تعداد غیبت: </b>{{ item.GheibatCount }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" style="direction: ltr;">
                    <v-btn class="grid" color="red white--text" rounded @click="goToGheibat(item.ID)">
                      {{ "جزییات حضور و غیاب" }}
                    </v-btn>
                  </v-col>
                </v-row>



                <br />
              </td>
            </template>
          </v-data-table>
          <hr v-if="index != cycles.length" />
        </div>
      </div>

    </div>
    <div v-else-if="!apiRunning" style="margin: 20px">
      هيچ دوره اي ثبت نشده است
    </div>
    <app-gheibat v-if="detailLevel == 2" :regId="selectedVahed"></app-gheibat>
  </div>
</template>

<script>
import { getAllCycles } from "@/api/cycle";
import DetailRow from "@/components/DetailRow";
import GheibatSingle from "./GheibatSingle";
import Cycle from "./Cycle";
export default {
  components: {
    appCycle: Cycle,
    appRow: DetailRow,
    appGheibat: GheibatSingle

  },
  data() {
    return {
      selectedCycle: -1,
      selectedVahed: -1,
      courseHeaders: [
        {
          text: "عنوان درس",
          value: "TitleName",
          width: "20%",
        },
        // {
        //   text: "نام استاد",
        //   value: "TeacherName",
        //   width: "20%",
        // },
        { text: "نمره نهایی", value: "Score", width: "8%" },
        { text: "وضعیت", value: "State", width: "8%" },
        //{ text: "کد درس", value: "ID", width: "8%" },
        //  { text: "پایه", value: "PayehName", width: "10%" },
        // { text: "واحد", value: "Vahed", width: "7%" },
        { text: "نمره اول", value: "Score1", width: "7%" },
        { text: "نمره دوم", value: "Score2", width: "7%" },
        { text: "نمره سوم", value: "Score3", width: "7%" },
        { text: "نمره شفاهی", value: "ScoreShafahi", width: "8%" },
        { text: "نمره تحقیق", value: "ScoreResearch", width: "8%" },
        { text: "جزییات", value: "data-table-expand", width: "5%" },
      ],
      items: [
        { value: "-1", text: "همه نمرات" },
        { value: "1", text: "سطح يك" },
        { value: "2", text: "سطح دو" },
        { value: "1,2", text: "سطح یک و دو" },
        { value: "3", text: "سطح سه" },
        { value: "4", text: "سطح چهار" },
      ],
      type: "-1",
      cycles: [],
    };
  },
  created() {
    if (this.$route.query.index || this.$route.query.regId) {
      this.$router.replace({
        query: {}
      })
    }
    this.getAllCycles();
  },
  computed: {

    detailLevel() {
      return this.selectedVahed > -1 ? 2 : this.selectedCycle > -1 ? 1 : 0
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },
    courses() {
      return this.detailLevel == 1 ? this.cycles[this.selectedCycle].Courses : [];
    },

    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },

  methods: {
    getAllCycles() {
      this.$store.commit("SET_TABLE_TEXT", true);
      this.$store.commit("SET_API_RUNNING", true);
      return new Promise((resolve, reject) => {
        getAllCycles(this.type)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.cycles = response.data;

            this.$store.commit("SET_TABLE_TEXT", false);
            this.$store.commit("SET_API_RUNNING", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /**
     * show course details in mobile mode
     */
    onClickCourse(index) {
      // this.selectedCycle = index;
      const cycle = this.cycles[index];
      const headerName = `${cycle.Name}`
      this.$store.commit("SET_HEADER_TITLE", headerName);
      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: index
        }
      });

    },

    getCourseIcon(index) {
      return this.selectedVahed == index ? "angle-down" : "angle-left";
    },

    goToGheibat(id) {

      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          regId: id
        }
      });


    },
  },
  watch: {

    '$route'(to, from) {
      this.selectedCycle = this.$route.query.index ?? -1;
      this.selectedVahed = this.$route.query.regId ?? -1;
    }
  },


};
</script>
<style scoped>
hr {
  margin: 20px;
  height: 6px;
  background-color: darkorange;
  border: 0 none;
  border-radius: 5px;
}

.mobileGrid {
  padding-bottom: 10px;
}

.mobileGrid td {
  border: thin solid rgba(0, 0, 0, 0.12);
}

.cycle-info {
  float: right;
  padding: 0 20px;
  width: 50%;
}

.courses {
  background-color: #e8e8e8 !important;
}
</style>
